<template>
  <div v-if="show" :id="id" ref="toast" class="vcl-toast" :class="mode" tabindex="0" @keyup.escape="handleEscape">
    <div class="vcl-toast__left-section">
      <div id="toastIcon">
        <vp-icon v-if="mode=='success'" icon="check" :style="successStyle" />
        <vp-icon v-if="mode=='warning'" icon="exclamation" :style="warningStyle" />
        <vp-icon v-if="mode=='fail'" icon="fail" :style="failStyle" />
        <vp-icon v-if="mode=='info'" icon="info" :style="infoStyle" />
      </div>
    </div>
    <div class="vcl-toast__right-section">
      <div class="vcl-toast__title">{{ title }}</div>
      <div ref="toastBody" class="vcl-toast__body" v-html="body"></div>
    </div>
    <div class="vcl-toast__close" @click="close()">
      <vp-icon icon="close" style="color: #AFAFAF" />
    </div>
  </div>
</template>
<script>
import VpIcon from '../vp-icon/VpIcon.vue';

export default {
  name: 'VpToast',
  components: {
    VpIcon,
  },
  props: {
    id: {
      type: String,
      default: '',
    },
    mode: {
      type: String,
      default: 'success',
      validator(value) {
        return ['success', 'warning', 'info', 'fail'].indexOf(value) !== -1;
      },
    },
  },
  data() {
    return {
      show: false,
      title: 'Something went wrong',
      body: 'Please, contact Virtual Peaker',
      duration: 5000,
      timer: null,
    };
  },
  computed: {
    failStyle() {
      return {
        color: '#9A0D08',
        'font-size': '30px',
      };
    },
    infoStyle() {
      return {
        color: '#6290AA',
        'font-size': '30px',
      };
    },
    successStyle() {
      return {
        color: '#208F8C',
        'font-size': '30px',
      };
    },
    warningStyle() {
      return {
        color: '#D57920',
        'font-size': '30px',
      };
    },
  },
  methods: {
    open(msg) {
      if (this.timer) clearTimeout(this.timer);
      const { title = null, body = null, duration = null, clickEvents = null } = msg;
      if (title) {
        this.title = title;
      }
      if (body) {
        this.body = body;
      }
      if (duration) {
        this.duration = duration;
      }

      const middle = document.getElementById('vp-middle');
      if (middle) {
        middle.style.zIndex = 100;
      }
      this.show = true;

      this.timer = setTimeout(() => {
        this.close();
      }, this.duration);

      this.$nextTick(() => {
        this.$refs.toast.focus();
        if (clickEvents) {
          Object.keys(clickEvents).forEach((selector) => {
            const target = this.$refs.toastBody.querySelectorAll(selector);
            if (target.length) {
              target.forEach((element) => {
                element.addEventListener('click', clickEvents[selector]);
              });
            }
          });
        }
      });
    },
    close() {
      const middle = document.getElementById('vp-middle');
      if (middle) {
        middle.style.zIndex = 1;
      }
      this.show = false;
    },
    handleEscape() {
      this.close();
    },
  }
};
</script>
<style lang="scss" scoped>

@keyframes toastDisplayed {
  0% { top:-180px; }
  100% { top: 32px; }
}

 div.vcl-toast {
  $self: &;
  animation-name: toastDisplayed;
  animation-timing-function: ease-in-out;
  animation-duration: 600ms;
  transition-timing-function: ease-in-out;
  background-color: #fff;
  border-radius:6px;
  min-height:85px;
  top:32px;
  min-height: 72px;
  position:fixed;
  width:70%;
  left: 50%;
  transform: translateX(-50%);
  z-index:999;
  @media screen and (max-width: 600px) {
    width: 95%;
  }
  &__left-section {
    min-height:100%;
    position:absolute;
    top: -1px;
    bottom: -1px;
    left: -1px;
    padding: 0;
    margin: 0;
    width:75px;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    #toastIcon {
      height:30px;
      width:30px;
      position:relative;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  &__right-section {
    display: flex;
    flex-direction: column;
    margin-left: 75px;
    margin-right: 25px;
    padding: 15px 24px;
    #{ $self }__title {
      color: #4F4F4F;
      font-size:16px;
      font-weight:600;
      line-height:18px;
      width: 100%;
    }

    #{ $self }__body {
      display: inline-block;
      color: #4F4F4F;
      font-size:14px;
      margin-top:4px;
      padding-right: 24px;
      &::v-deep a {
        color: #4F4F4F;
        font-size:14px;
        text-decoration: underline;
      }
    }
  }
  &__close {
    cursor:pointer;
    position:absolute;
    right:24px;
    top: 50%;
    transform: translateY(-50%);
  }
  &.success {
    border: 3px solid #5BBFBD;
    #{ $self }__left-section {
      background-color: #5BBFBD;
    }
  }
  &.warning {
    border:3px solid #E9B05B;
    #{ $self }__left-section {
      background-color: #E9B05B;
    }
  }
  &.info {
    border:3px solid #A7CCE1;
    #{ $self }__left-section {
      background-color: #A7CCE1;
    }
  }
  &.fail {
    border:3px solid #CE3C31;
    #{ $self }__left-section {
      background-color: #CE3C31;
    }
  }
 }
</style>
